module.exports = __webpack_public_path__ + "img/50f2.bfa6c724.jpg";